import Api from "~/service/Api";

class UiMeet3dPhotoRepository {
  fetch(query) {
    return Api.get("/ui-meet-3d/photos", query);
  }

  create(data) {
    return Api.post("/ui-meet-3d/photos", data);
  }

  delete(uiMeet3dPhotoId) {
    return Api.delete(`/ui-meet-3d/photos/${uiMeet3dPhotoId}`);
  }
}

export default UiMeet3dPhotoRepository;
